exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gray-route-container[data-v-6065a013] {\n  padding-top: 8px;\n}\n.search-form[data-v-6065a013] {\n  margin-bottom: 12px;\n}\n", ""]);

// exports
